import { render } from "./modal-edit-task.vue?vue&type=template&id=5fb8effd"
import script from "./modal-edit-task.vue?vue&type=script&lang=js"
export * from "./modal-edit-task.vue?vue&type=script&lang=js"

import "./modal-edit-task.vue?vue&type=style&index=0&id=5fb8effd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__